import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoVinculoTrabalho, cadastrarTipoVinculoTrabalho, alterarTipoVinculoTrabalho, excluirTipoVinculoTrabalho, } from './tipos_vinculos_trabalho.service';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
export var TiposVinculosTrabalhosAlterar = function () {
    var services = {
        getItem: getTipoVinculoTrabalho,
        cadastrarItem: cadastrarTipoVinculoTrabalho,
        alterarItem: alterarTipoVinculoTrabalho,
        excluirItem: excluirTipoVinculoTrabalho,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_VINCULOS_TRABALHO, paginaPermissao: FUNCIONALIDADES.TIPOS_VINCULOS_TRABALHO, rota: ROUTES.TIPOS_VINCULOS_TRABALHO, services: services });
};
export default TiposVinculosTrabalhosAlterar;
